<template>
  <section id="press" class="spacer">
    <div class="big title">{{ press.title }}</div>
    <div v-for="item in press.items" :key="item.title" class="big pt">
      <a target="_blank" :href="item.link">{{ item.title }}</a>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      press: []
    };
  },
  created() {
    API.press(this.$i18n.locale).then(page => {
      this.press = page.data.result;
    });
  }
};
</script>

<style lang="scss" scoped>
.year {
  padding-bottom: var(--lh);
  border-bottom: var(--b) solid var(--color);
  &:last-of-type {
    padding-bottom: 0;
    border-bottom: 0;
  }
}
</style>
